import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import EmployeeNavigator from "../../../navigation/EmployeeNavigator";
import styles from "./employeeSettings.module.css";

const EmployeeSettings = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {rolePermissions.includes("view-admins") && (
            <div className={styles.linkWrapper}>
              <PageLink destination="/dashboard/emlpoyees/show-all-employees">
                عرض جميع الموظفين
              </PageLink>
            </div>
          )}
          {rolePermissions.includes("create-admins") && (
            <div className={styles.linkWrapper}>
              <PageLink destination="/dashboard/emlpoyees/add-new-employee">
                اضافة موظف جديد
              </PageLink>
            </div>
          )}
          {rolePermissions.includes("control-hierarchy") && (
            <div className={styles.linkWrapper}>
              <PageLink destination="/dashboard/emlpoyees/control-hierarchy">
                التحكم في تسلسل الموظفين
              </PageLink>
            </div>
          )}
        </div>
      </HorizantalBar>
      <EmployeeNavigator />
    </div>
  );
};

export default EmployeeSettings;
